import { createFeature } from '@ngrx/store';
import { downloadReducer, exportReducer } from '../reducers';

/**
 * @DOWNLOAD FEATURE STATE
 */
export const DOWNLOADS_FEATURE_STATE = createFeature({
  name: 'downloads',
  reducer: downloadReducer,
});

/**
 * @EXPORTS FEATURE STATE
 */

export const EXPORTS_FEATURE_STATE = createFeature({
  name: 'exports',
  reducer: exportReducer,
});
